import React from 'react';
import { FormControl, FormGroup } from 'react-bootstrap';

export const DateRangeDurationPickerInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'> & {
    inputRef?: React.RefObject<HTMLInputElement>;
    borderless?: boolean;
    inputStyle?: React.CSSProperties;
  }
>(({ onClick, value, placeholder, disabled, borderless, style, inputStyle, inputRef }, ref) => (
  <FormGroup ref={ref} style={{ margin: 0, ...style }} onClick={onClick as any}>
    <FormControl
      ref={inputRef}
      plaintext
      readOnly
      autoComplete="off"
      disabled={disabled}
      placeholder={placeholder}
      style={{
        opacity: disabled ? 0.5 : 1,
        fontSize: '14px',
        minHeight: '48px',
        padding: '0 8px',
        textAlign: 'center',
        minWidth: '40px',
        background: 'transparent',
        ...inputStyle,
        ...(borderless ? { border: 'none' } : {}),
        color: 'var(--primary-text)',
      }}
      type="text"
      value={(value as any) ?? ''}
      onFocus={(e) => e.preventDefault()}
    />
  </FormGroup>
));

export default DateRangeDurationPickerInput;
